import find from "lodash/fp/find";
import findIndex from "lodash/fp/findIndex";

class RealtimeRide {
  constructor($injector) {
    "ngInject";

    this.Captain = $injector.get("Captain");
    this.Events = $injector.get("Events");
    this.RideTransforms = $injector.get("RideTransforms");
    this.rideStatus = [
      { name: "stopped", title: "Stopped" },
      { name: "started", title: "Started" },
      { name: "scheduled", title: "Scheduled" },
      { name: "completed", title: "Completed" },
      { name: "cancelled", title: "cancelled" },
    ];
    this.infoNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  check(data, ride) {
    this.ride = ride;
    this.checkStation(data.currentStation);

    this.ride.captain = this.checkCaptain(data.captainId);
    this.ride.status = this.checkStatus(data.status);
    this.ride.bookings = this.checkCapacity(data.capacity);
    this.ride.stationsSchedules = this.checkTimings(
      data.arrivals,
      data.departures,
      ride
    );

    return this.ride;
  }

  checkCaptain(captainId) {
    if (!captainId) return this.ride.captain;
    if (this.ride.captain._id === captainId) return this.ride.captain;

    const captain = this.Captain.get(captainId);
    captain.$promise.then((response) => {
      response.isDisabled = true;
      this.Events.emit(this.infoNotificationEvent, {
        message: 'Ride "captain" has been changed',
      });

      return response;
    });

    return captain;
  }

  checkStatus(status) {
    if (!status) return this.ride.status;
    if (!this.ride.status.name || this.ride.status.name === status) {
      return this.ride.status;
    }
    const statusObj = find((i) => i.name === status)(this.rideStatus);

    this.Events.emit(this.infoNotificationEvent, {
      message: 'Ride "status" has been changed',
    });
    this.ride.status.name = status;
    this.ride.status.title = statusObj.title;
    return this.ride.status;
  }

  checkCapacity(capacity) {
    if (!capacity) return this.ride.bookings;
    if (
      this.ride.bookings.count === capacity.count &&
      this.ride.bookings.maximum === capacity.maximum
    ) {
      return this.ride.bookings;
    }

    this.Events.emit(this.infoNotificationEvent, {
      message: 'Ride "count & maximum" have been changed',
    });
    this.ride.bookings.count = capacity.count;
    this.ride.bookings.maximum = capacity.maximum;
    return this.ride.bookings;
  }

  checkStation(currentStation) {
    if (!currentStation) return;
    const findById = (item) => item._id === currentStation._id;
    const comingStationIndex = findIndex(findById)(this.ride.coming_stations);

    if (comingStationIndex >= 0) {
      const movedStations = this.ride.coming_stations.slice(
        0,
        comingStationIndex + 1
      );

      const newComingStations = this.ride.coming_stations.slice(
        comingStationIndex + 1,
        this.ride.coming_stations.length
      );

      this.ride.past_stations = [...this.ride.past_stations, ...movedStations];
      this.ride.coming_stations = newComingStations;
    }
  }

  checkTimings(arrivals, departures, ride) {
    if (arrivals.length <= 0 && departures.length <= 0) return ride;

    ride.arrivals = arrivals;
    ride.departures = departures;

    return this.RideTransforms.mapSchedule(ride);
  }
}

export default RealtimeRide;



// WEBPACK FOOTER //
// ./src/services/realtimeRide/realtimeRide.service.js